import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetSummaryListCtrl = function (fn, er, state, typeCall, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		abi: state.abi,
		codPos: state.codepv,
		pos: state.codpos,
		day: state.selectedDay,
		maxGrossCalculated: state.maxamount,
		maxGrossDeclared: state.maxamountnet,
		minGrossCalculated: state.minamount,
		minGrossDeclared: state.minamountnet,
		month: state.selectedMonthYear,
		orderBy: "",
		typeCall: typeCall === undefined ? "X" : typeCall,
		page: state.currentPage
	};

	axios
		.post(ApiConfig.url.GET_SUMMARY_LIST, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetSummaryListCtrl };